export default __webpack_public_path__ + "static/media/etna.a17cb1da.otf";